import styled from 'styled-components';
import {boxShadow, GRAY3, mobileMedia, scrollbar, WHITE} from '../../../../globalVariables/GlobalVariables';

export const card = styled.div`
  height: max-content;
  background-color: ${WHITE};
  border-radius: 18px;
  padding: 32px;
  width: 100%;
  max-width: 600px;
  max-height: 95%;
  ${scrollbar};
  ${boxShadow};
  ${mobileMedia}{
    width: 96vw;
    padding: 15px;
  }
`;
export const footer = styled.div`
  text-align: center;
  font-size: 14px;
  color: ${GRAY3};
`;
